document.querySelector(".to-top").addEventListener("click", function (e) {
  e.preventDefault();
  console.log(2);
  

  document.documentElement?.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});
